import React from 'react';

export default {
  width: 233,
  height: 10,
  content: <path stroke="#151716" strokeWidth="2" d="M0 5h230M226.855 1.293L231.148 5l-4.293 4"></path>
};
